import { createSelector } from 'reselect'
import { values } from 'lodash'

import { getSalesEventTypes } from 'store/SalesEventTypes/selectors'

export const getPriceLevels = (state) =>
  values(state?.priceLevels?.byId ?? {})

export const getIsPriceLevelsLoading = (state) =>
  state?.priceLevels?.isLoading ?? false

export const getPriceLevelsPerSalesEventType = createSelector(
  getPriceLevels,
  getSalesEventTypes,
  (priceLevels, salesEventTypes) =>
    salesEventTypes.reduce((acc, salesEventType) => {
      const matchingPriceLevels = priceLevels.filter(
        ({ salesEventTypeId }) =>
          salesEventTypeId === salesEventType.uuid
      )

      const transformedLevels = matchingPriceLevels.map(
        (matchingPriceLevel) => ({
          name: salesEventType.name,
          price: matchingPriceLevel?.wholePrice ?? '',
          salesEventTypeId: salesEventType?.uuid ?? null,
          itemPropertyOverridesUuid: matchingPriceLevel?.uuid ?? null,
          itemUuid: matchingPriceLevel.itemUuid,
        })
      )

      return [...acc, ...transformedLevels]
    }, [])
)
